module.exports = __webpack_public_path__ + "static/media/2.6d819e01.png";